import {API_DRIVER} from "../configs/axios";

const ServiceRequestsService = {
    fetchAperte: (integrationId, searchText, filterBy, sorting, page, rowsPerPage, cancelToken) => {
        return API_DRIVER.get(`/api/serviceRequest/aperte`, {
            params: {
                integrationId: integrationId,
                sort: sorting,
                page: page,
                size: rowsPerPage,
                ...(searchText.length !== 0 && {[filterBy]: searchText})
            },
            cancelToken: cancelToken
        })
    },
    fetchArchiviate: (integrationId, searchText, filterBy, sorting, page, rowsPerPage, cancelToken) => {
        return API_DRIVER.get(`/api/serviceRequest/archiviate`, {
            params: {
                integrationId: integrationId,
                sort: sorting,
                page: page,
                size: rowsPerPage,
                ...(searchText.length !== 0 && {[filterBy]: searchText})
            },
            cancelToken: cancelToken
        })
    },
    fetchSuggestion: (query, cancelToken) => {
        return API_DRIVER.get(`/api/serviceRequest/autocomplete${query}`, {
            cancelToken: cancelToken
        })
    },
    fetchCategories: (integrationId, assistenzaId, screenCode, returnReferente, changeInSelf, prodottoId) => {
        return API_DRIVER.get(`/api/serviceRequest/categories`, {
            params: {
                customerId: integrationId,
                assistenzaId: assistenzaId,
                screenCode: screenCode,
                returnReferente: returnReferente,
                changeInSelf: changeInSelf,
                prodottoId
            }
        })
    },
    fetchAreas: (integrationId, assistenzaId, screenCode, categoriaId, changeInSelf, prodottoId) => {
        return API_DRIVER.get(`/api/serviceRequest/areas`, {
            params: {
                customerId: integrationId,
                assistenzaId: assistenzaId,
                screenCode: screenCode,
                categoriaId: categoriaId,
                changeInSelf: changeInSelf,
                prodottoId
            }
        })
    },
    fetchDettaglio: (integrationId, assistenzaId, screenCode, categoriaId, areaId, changeInSelf, prodottoId) => {
        return API_DRIVER.get(`/api/serviceRequest/dettaglio`, {
            params: {
                customerId: integrationId,
                assistenzaId: assistenzaId,
                screenCode: screenCode,
                categoriaId: categoriaId,
                areaId: areaId,
                changeInSelf: changeInSelf,
                prodottoId
            }
        })
    },
    reportProblem: (body) => {
        return API_DRIVER.post(`/api/serviceRequest/reportProblem`, body)
    },
    fetchOperators: (integrationId) => {
        return API_DRIVER.get(`/api/serviceRequest/operator/integrationId/${integrationId}`)
    },
    rechargeSim: (body) => {
        return API_DRIVER.post('/api/serviceRequest/sim/recharge', body)
    },
    changeThreshold: (body) => {
        return API_DRIVER.post('/api/serviceRequest/sim/changeThreshold', body)
    },
    sendSomRequest: (body) => {
        return API_DRIVER.post('/api/serviceRequest/sim/som', body)
    },
    fetchAddressForCustomerId: (integrationId) => {
        return API_DRIVER.get(`/api/serviceRequest/address/customer/${integrationId}`)
    },
    fetchRamGroups: (body) => {
        return API_DRIVER.post(`/api/serviceRequest/ramGroup`, body)
    },
    fetchFaqs: (searchText) => {
        return API_DRIVER.get(`/api/serviceRequest/faq`, {
            params: {
                searchText
            }
        })
    }
}

export default ServiceRequestsService
